// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  version: require('../../package.json').version,
  production: false,
  AIRTABLE_API_KEY:
    'pat3LiQFP6MDa11qf.a5eead7a08c39ad6ffecd1fc5d984ce73f47786f54123d73f54b585aad266845',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
